import { JobEventFilter } from './job-event.filter';
const camelcaseKeysDeep = require('camelcase-keys-deep');
const decamelizeKeysDeep = require('decamelize-keys-deep');

export class JobEventFilterSerializer {
  fromJson(json: any): JobEventFilter {
    json = camelcaseKeysDeep(json);
    const jobEventFilter = new JobEventFilter();
    if (!json) { return jobEventFilter; }
    jobEventFilter.id = json.id;
    jobEventFilter.name = json.name;

    return jobEventFilter;
  }

  toJson(jobEventFilter: JobEventFilter): any {
    let json = {
      id: jobEventFilter.id,
      name: jobEventFilter.name
    };

    return decamelizeKeysDeep(json);
  }
}
